// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.connect-accounts {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  background: #fff;
}

.connect-accounts-header {
  text-align: center;
  margin-bottom: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.connect-accounts-header h1 {
  font-size: 2.5rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 1rem;
}

.connect-accounts-header p {
  font-size: 1.1rem;
  color: #6b7280;
  margin-bottom: 0.5rem;
}

.processing-auth,
.auth-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: 1rem;
}

.processing-auth h2,
.auth-error h2 {
  color: #374151;
  margin: 0;
}

.processing-auth p,
.auth-error p {
  color: #6b7280;
  margin: 0;
  text-align: center;
}

.auth-error .error-icon {
  font-size: 3rem;
  margin-bottom: 1rem;
}

.auth-error button {
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  margin-top: 1rem;
}

.platforms-section {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3rem;
  margin-bottom: 3rem;
}

.platform-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  min-width: 280px;
  text-align: center;
}

.platform-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.platform-header h3 {
  font-size: 1.3rem;
  font-weight: 600;
  color: #1f2937;
  margin: 0;
}

.platform-logo {
  width: 64px;
  height: 64px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
}

.platform-logo.hubspot-logo {
  background: #ff7a59;
}

.platform-logo.salesforce-logo {
  background: #00a1e0;
}

.platform-logo img {
  width: 40px;
  height: 40px;
  object-fit: contain;
  filter: brightness(0) invert(1);
}

.connection-status {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.status-indicator {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.7rem;
  font-weight: bold;
}

.status-indicator.connected {
  background: #10b981;
  color: white;
}

.status-indicator.disconnected {
  background: #ef4444;
  color: white;
}

.status-text {
  font-size: 0.9rem;
  font-weight: 500;
  color: #374151;
}

.error-message {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 6px;
  padding: 0.75rem;
  margin-bottom: 1rem;
  font-size: 0.85rem;
  color: #dc2626;
}

.connection-actions {
  margin-bottom: 1rem;
}

.connect-button {
  width: 100%;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}

.connect-button.hubspot {
  background: #ff7a59;
  color: white;
}

.connect-button.hubspot:hover {
  background: #ff6b47;
}

.connect-button.salesforce {
  background: #00a1e0;
  color: white;
}

.connect-button.salesforce:hover {
  background: #0091cc;
}

.connect-button.connected {
  background: #10b981;
  color: white;
}

.connect-button.connected:hover {
  background: #059669;
}

.connect-button.disabled {
  background: #9ca3af;
  color: white;
  cursor: not-allowed;
}

.tenant-info {
  font-size: 0.8rem;
  color: #6b7280;
  margin-top: 0.5rem;
}

.sync-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.note-section {
  text-align: center;
  /* margin-bottom: 3rem; */
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.note {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: #fef3c7;
  border: 1px solid #fbbf24;
  border-radius: 8px;
  padding: 0.75rem 1rem;
  font-size: 0.9rem;
  margin-bottom: 1rem;
}

.note-icon {
  font-size: 1.1rem;
}

.note-text {
  color: #92400e;
}

.features-section {
  margin-bottom: 3rem;
}

.features-section h2 {
  text-align: center;
  font-size: 1.5rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 2rem;
}

.features-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-width: 600px;
  margin: 0 auto;
  justify-content: center;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
  background: #f9fafb;
  border-radius: 8px;
}

.CA-feature-icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.actions-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 2rem;
  border-top: 1px solid #e5e7eb;
}

.back-button {
  background: #f9fafb;
  color: #374151;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.back-button:hover {
  background: #f3f4f6;
  border-color: #9ca3af;
}

.next-button {
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 0.75rem 2rem;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.next-button:hover:not(:disabled) {
  background: #2563eb;
}

.next-button:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

/* Responsive Design */
@media (max-width: 768px) {
  .connect-accounts {
    padding: 1rem;
  }

  .platforms-section {
    flex-direction: column;
    gap: 2rem;
  }

  .sync-icon {
    transform: rotate(90deg);
  }

  .actions-section {
    flex-direction: column;
    gap: 1rem;
  }

  .back-button,
  .next-button {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Connector-Screen/ConnectAccounts/ConnectAccounts.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,8EAA8E;EAC9E,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,WAAW;EACb;AACF","sourcesContent":[".connect-accounts {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  background: #fff;\n}\n\n.connect-accounts-header {\n  text-align: center;\n  margin-bottom: 3rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.connect-accounts-header h1 {\n  font-size: 2.5rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 1rem;\n}\n\n.connect-accounts-header p {\n  font-size: 1.1rem;\n  color: #6b7280;\n  margin-bottom: 0.5rem;\n}\n\n.processing-auth,\n.auth-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  gap: 1rem;\n}\n\n.processing-auth h2,\n.auth-error h2 {\n  color: #374151;\n  margin: 0;\n}\n\n.processing-auth p,\n.auth-error p {\n  color: #6b7280;\n  margin: 0;\n  text-align: center;\n}\n\n.auth-error .error-icon {\n  font-size: 3rem;\n  margin-bottom: 1rem;\n}\n\n.auth-error button {\n  background: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 0.75rem 2rem;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  margin-top: 1rem;\n}\n\n.platforms-section {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 3rem;\n  margin-bottom: 3rem;\n}\n\n.platform-card {\n  background: white;\n  border: 1px solid #e5e7eb;\n  border-radius: 12px;\n  padding: 2rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  min-width: 280px;\n  text-align: center;\n}\n\n.platform-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.platform-header h3 {\n  font-size: 1.3rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin: 0;\n}\n\n.platform-logo {\n  width: 64px;\n  height: 64px;\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px;\n}\n\n.platform-logo.hubspot-logo {\n  background: #ff7a59;\n}\n\n.platform-logo.salesforce-logo {\n  background: #00a1e0;\n}\n\n.platform-logo img {\n  width: 40px;\n  height: 40px;\n  object-fit: contain;\n  filter: brightness(0) invert(1);\n}\n\n.connection-status {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-bottom: 1rem;\n}\n\n.status-indicator {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 0.7rem;\n  font-weight: bold;\n}\n\n.status-indicator.connected {\n  background: #10b981;\n  color: white;\n}\n\n.status-indicator.disconnected {\n  background: #ef4444;\n  color: white;\n}\n\n.status-text {\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #374151;\n}\n\n.error-message {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 6px;\n  padding: 0.75rem;\n  margin-bottom: 1rem;\n  font-size: 0.85rem;\n  color: #dc2626;\n}\n\n.connection-actions {\n  margin-bottom: 1rem;\n}\n\n.connect-button {\n  width: 100%;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: none;\n}\n\n.connect-button.hubspot {\n  background: #ff7a59;\n  color: white;\n}\n\n.connect-button.hubspot:hover {\n  background: #ff6b47;\n}\n\n.connect-button.salesforce {\n  background: #00a1e0;\n  color: white;\n}\n\n.connect-button.salesforce:hover {\n  background: #0091cc;\n}\n\n.connect-button.connected {\n  background: #10b981;\n  color: white;\n}\n\n.connect-button.connected:hover {\n  background: #059669;\n}\n\n.connect-button.disabled {\n  background: #9ca3af;\n  color: white;\n  cursor: not-allowed;\n}\n\n.tenant-info {\n  font-size: 0.8rem;\n  color: #6b7280;\n  margin-top: 0.5rem;\n}\n\n.sync-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.note-section {\n  text-align: center;\n  /* margin-bottom: 3rem; */\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.note {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: #fef3c7;\n  border: 1px solid #fbbf24;\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  font-size: 0.9rem;\n  margin-bottom: 1rem;\n}\n\n.note-icon {\n  font-size: 1.1rem;\n}\n\n.note-text {\n  color: #92400e;\n}\n\n.features-section {\n  margin-bottom: 3rem;\n}\n\n.features-section h2 {\n  text-align: center;\n  font-size: 1.5rem;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 2rem;\n}\n\n.features-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  max-width: 600px;\n  margin: 0 auto;\n  justify-content: center;\n}\n\n.feature-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1rem;\n  background: #f9fafb;\n  border-radius: 8px;\n}\n\n.CA-feature-icon {\n  font-size: 1.5rem;\n  flex-shrink: 0;\n}\n\n.actions-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 2rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.back-button {\n  background: #f9fafb;\n  color: #374151;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  padding: 0.75rem 2rem;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.back-button:hover {\n  background: #f3f4f6;\n  border-color: #9ca3af;\n}\n\n.next-button {\n  background: #3b82f6;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  padding: 0.75rem 2rem;\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.next-button:hover:not(:disabled) {\n  background: #2563eb;\n}\n\n.next-button:disabled {\n  background: #9ca3af;\n  cursor: not-allowed;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .connect-accounts {\n    padding: 1rem;\n  }\n\n  .platforms-section {\n    flex-direction: column;\n    gap: 2rem;\n  }\n\n  .sync-icon {\n    transform: rotate(90deg);\n  }\n\n  .actions-section {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .back-button,\n  .next-button {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
